export const navigationRef = {
  navigate: null,
}

export function navigate(path, options) {
  // Check if the navigate function has been set before calling it.
  if (navigationRef.navigate) {
    navigationRef.navigate(path, options)
  }
}
